import manager from '@/functions/manager';
import '@/functions';
import $ from 'jquery'
import lazy from '@/utils/lazy'
import './lazy.css'

window.manager=manager
export function activeModules(arr) {
    arr.forEach(async dom => {
        if(!$(dom).children().attr("force-load-module-function")){
            await lazy(dom)
        }
        manager.active(dom)
    })
}

export function activeLazyImageDom(dom) {
    $(dom).attr("src", $(dom).attr("data-src")).addClass("lazy-finish")
}
export function activeAllLazyImageDom(dom) {
    Array.from(dom.querySelectorAll("[lazy-image]")).forEach(imgdom => {
        activeLazyImageDom(imgdom)
    })
}

export async function watchLazyImageDom(dom) {
    await lazy(dom)
    activeLazyImageDom(dom)
}

export function activeLazyImage() {
    Array.from(document.querySelectorAll("[lazy-image]")).forEach(async dom => {
        await lazy(dom)
        activeLazyImageDom(dom)
    })
}